var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.292 3.1378L5.105 3.26699V6.41053V9.55407L4.85 9.41627C4.5355 9.25263 4.306 9.25263 4.136 9.42488C4.017 9.54545 4 10.1828 4 15.1349C4 20.4316 4.0085 20.7244 4.153 20.8536C4.2975 20.9914 5.003 21 12.517 21C20.354 21 20.728 20.9914 20.8555 20.845C20.983 20.6986 21 20.1818 21 15.1263C21 9.8555 20.9915 9.56268 20.847 9.43349C20.6515 9.25263 20.4645 9.25263 20.15 9.41627L19.895 9.55407V6.44498C19.895 3.45646 19.8865 3.33589 19.725 3.17225C19.555 3 19.4445 3 12.517 3C6.2865 3 5.462 3.01723 5.292 3.1378ZM18.96 6.97895C18.96 8.6067 18.926 9.97608 18.892 10.0278C18.824 10.1311 12.6275 13.4211 12.4915 13.4211C12.449 13.4211 10.987 12.6718 9.2445 11.7502L6.0825 10.0794L6.057 7.05646L6.04 4.03349H12.5H18.96V6.97895ZM5.717 11.001C9.984 13.2919 12.4405 14.5407 12.602 14.489C12.6955 14.4632 14.3785 13.5847 16.3335 12.5512C18.2885 11.5177 19.929 10.6651 19.98 10.6651C20.0395 10.6651 20.0565 12.1636 20.048 15.333L20.0225 20.0096H12.5H4.9775L4.952 15.333C4.9435 12.4909 4.9605 10.6651 5.0115 10.6651C5.054 10.6651 5.3685 10.8115 5.717 11.001Z",
    fill: "#545B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02609 6.11667C8.00035 6.175 7.99177 6.39167 8.00893 6.59167L8.03466 6.95833L12.5216 6.98333L17 7V6.5V6H12.5388C8.81538 6 8.0604 6.01667 8.02609 6.11667Z",
    fill: "#545B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02609 9.11667C8.00035 9.175 7.99177 9.39167 8.00893 9.59167L8.03466 9.95833L12.5216 9.98333L17 10V9.5V9H12.5388C8.81538 9 8.0604 9.01667 8.02609 9.11667Z",
    fill: "#545B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b6c7768c0c0d807fd474f86170fbed45.svg";
export { ForwardRef as ReactComponent };